var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.8vw",
    height: "1.7vw",
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    rx: 5,
    fill: "#50C878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 17C15.9375 16.453 16.1548 15.9284 16.5416 15.5416C16.9284 15.1548 17.453 14.9375 18 14.9375C18.547 14.9375 19.0716 15.1548 19.4584 15.5416C19.8452 15.9284 20.0625 16.453 20.0625 17C20.0625 17.547 19.8452 18.0716 19.4584 18.4584C19.0716 18.8452 18.547 19.0625 18 19.0625C17.453 19.0625 16.9284 18.8452 16.5416 18.4584C16.1548 18.0716 15.9375 17.547 15.9375 17Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83301 17.0003C8.83301 18.5037 9.22259 19.0087 10.0018 20.0217C11.5573 22.042 14.1662 24.3337 17.9997 24.3337C21.8332 24.3337 24.442 22.042 25.9976 20.0217C26.7768 19.0097 27.1663 18.5027 27.1663 17.0003C27.1663 15.497 26.7768 14.9919 25.9976 13.979C24.442 11.9587 21.8332 9.66699 17.9997 9.66699C14.1662 9.66699 11.5573 11.9587 10.0018 13.979C9.22259 14.9928 8.83301 15.4979 8.83301 17.0003ZM17.9997 13.5628C17.088 13.5628 16.2137 13.925 15.569 14.5696C14.9243 15.2143 14.5622 16.0886 14.5622 17.0003C14.5622 17.912 14.9243 18.7863 15.569 19.431C16.2137 20.0757 17.088 20.4378 17.9997 20.4378C18.9114 20.4378 19.7857 20.0757 20.4304 19.431C21.075 18.7863 21.4372 17.912 21.4372 17.0003C21.4372 16.0886 21.075 15.2143 20.4304 14.5696C19.7857 13.925 18.9114 13.5628 17.9997 13.5628Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackEyeIcon);
export default __webpack_public_path__ + "static/media/blackEyeIcon.a8b70358ea9307c8735cd1b4dd481ea9.svg";
export { ForwardRef as ReactComponent };